export enum AutomationForgeElementType {
  SEND_EMAIL = "send-email",
  SEND_SMS = "send-sms",
  SEND_WEBHOOK = "send-webhook",
  MANAGE_CUSTOMER_TAGS = "manage-customer-tags",
  MANAGE_STATIC_SEGMENT = "manage-static-segment",
  RECOVER = "recover",
  WAIT = "wait",
  WAIT_FOR_EVENT = "wait-for-event",
  BRANCH = "branch",
  END = "end",

  // 1CU (legacy)
  UPSELL = "upsell",
  DOWNSELL = "downsell",

  // OMS
  OMS_ACTION = "oms-action",
  OMS_CONDITION = "oms-condition",

  // CHECKOUT PARCELS
  RCO_PARCEL_CONDITION = "rco-parcel-condition",
  RCO_PARCEL = "rco-parcel",

  // CHECKOUT TREE
  CHECKOUT_EXPERIENCE = "checkout-experience",
  RCO_SEGMENT = "rco-segment",
  RCO_SPLIT = "rco-split",
  BLOCK_CHECKOUT = "block-checkout",

  // A/B Testing
  AB_TEST = "ab-test",

  // Post-purchase flow (v1)
  POST_PURCHASE_PAGE = "post-purchase-page",
  POST_PURCHASE_SEGMENT = "post-purchase-segment",
  POST_PURCHASE_SPLIT = "post-purchase-split",

  // Tracking page flows
  TRACKING_PAGE = "tracking-page",

  // Support rules
  RULE_CONDITIONS = "rule_conditions",
  RULE_ACTIONS = "rule_actions",
  RULE_CONDITIONS_V3 = "rule_conditions_v3",
  RULE_ACTIONS_V3 = "rule_actions_v3",

  // Work order flows
  WORK_ORDER_WORK_STEP = "work-order-work-step",
  WORK_ORDER_CONDITION = "work-order-condition",

  // Return processing flows
  PROCESS_RETURN = "process-return",
}

export const MarketingAutomationForgeActions = [
  AutomationForgeElementType.SEND_EMAIL,
  AutomationForgeElementType.SEND_SMS,
  AutomationForgeElementType.SEND_WEBHOOK,
  AutomationForgeElementType.MANAGE_CUSTOMER_TAGS,
  AutomationForgeElementType.MANAGE_STATIC_SEGMENT,
  AutomationForgeElementType.RECOVER,
];

export const MarketingAutomationForgeRules = [
  AutomationForgeElementType.BRANCH,
  AutomationForgeElementType.WAIT,
  AutomationForgeElementType.AB_TEST,
];

export const UpsellForgeActions = [
  AutomationForgeElementType.UPSELL,
  AutomationForgeElementType.DOWNSELL,
];

export const UpsellForgeRules = [AutomationForgeElementType.BRANCH];

export const ReturnProcessingForgeActions = [
  AutomationForgeElementType.PROCESS_RETURN,
  AutomationForgeElementType.END,
];

export const ReturnProcessingForgeRules = [
  AutomationForgeElementType.BRANCH,
  AutomationForgeElementType.WAIT,
];
